import { useState, useEffect } from "react";

/**
 * @param {Array<import("../common/formatting").Extractor>} head
 * @returns {{[key: string]: Array<Option>}}
 */
const useOptions = (head) => {
  const [options, setOptions] = useState({});

  useEffect(() => {
    if (head == null) {
      return;
    }
    const fetchData = async () => {
      let bufOptions = {};
      for (const extractor of head) {
        if (extractor.fetchOptions == null) {
          continue;
        }
        try {
          bufOptions[extractor.extractor] = await extractor.fetchOptions();
        } catch (e) {
          console.error(
            `Failed to fetch options for ${extractor.extractor} with ${e}`,
          );
          bufOptions[extractor.extractor] = [];
        }
      }
      setOptions(bufOptions);
    };
    fetchData();
  }, [head]);

  return { options };
};

export default useOptions;
